import axios from "axios";
import { automationClient } from "../api/automationClient";

const prod_teleserver_url = process.env.REACT_APP_PROD_TELESERVER_URL;
const v2_teleserver_url = process.env.REACT_APP_TELESERVER_API_URL;

export const startProdServices = async (flow_id, server_version = "") => {
  try {
    const params = {};
    if (server_version) {
      params.server_version = server_version;
    }
    const response = await automationClient.put(
      `v1/orchestration/start/prod/${flow_id}`,
      {},
      { params }
    );
    return response;
  } catch (err) {
    console.error("Error occurred while starting prod services");

    throw new Error("Some error occurred while starting prod services");
  }
};

export const getProdServicesStatus = async (flow_id, server_version = "") => {
  try {
    const params = {};
    if (server_version) {
      params.server_version = server_version;
    }
    const response = await automationClient.get(
      `v1/orchestration/status/prod/${flow_id}`,
      { params }
    );
    return response;
  } catch (err) {
    console.error("Error occurred while getting prod services status");

    throw new Error("Some error occurred while getting prod services status");
  }
};

export const getProdServicesStatusFromTeleserver = async (
  flow_id,
  server_version = ""
) => {
  try {
    let response;
    if (server_version === "v2") {
      response = await axios.get(
        `${v2_teleserver_url}service/status/${flow_id}`,
        {
          headers: {
            "x-api-key": `${process.env.REACT_APP_X_API_KEY_PUBLIC}`,
          },
        }
      );
    } else {
      response = await axios.get(
        `${prod_teleserver_url}service/status/${flow_id}`
      );
    }
    return response;
  } catch (err) {
    console.error(
      "Error occurred while getting prod services status from teleserver"
    );

    throw new Error("Some error occurred while getting prod services status");
  }
};
